
<div
  :class="{ 'is-hidden': !hasSuggestions }"
  class="c-header-search__block -lateral-padded"
>
  <div class="o-grid -vertical-gutter -xs-gutter-small">
    <div
      v-for="(suggestedSearch, index) in suggestedSearches.products"
      :key="`product-search-${index}`"
      class="c-header-search__block-suggestion"
    >
      <!-- eslint-disable vue/no-v-html -->
      <button
        type="button"
        class="o-text -xs-extra-dark -xs-medium -xs-long-primer t-text-left"
        @click="chooseSuggestedSearch(suggestedSearch, productsSearchContext)"
        v-html="getHighlightedSuggestedSearchHtml(suggestedSearch.text)"
      />
      <!-- eslint-enable -->
    </div>

    <div
      v-for="(suggestedSearch, index) in suggestedSearches.sellers"
      :key="`store-search-${index}`"
      class="c-header-search__block-suggestion-seller"
    >
      <a
        class="c-header-search__block-suggestion-seller-avatar-image"
        :href="suggestedSearch.url"
      >
        <img
          class="c-header-search__block-suggestion-seller-avatar-image"
          :alt="`Imagem da lojinha ${suggestedSearch.text}`"
          :src="
            suggestedSearch.image
              | enjuphotosUrl(enjuphotos.presets.userStore.avatar)
          "
        >
      </a>

      <!-- eslint-disable vue/no-v-html -->
      <button
        type="button"
        class="o-text -xs-extra-dark -xs-medium -xs-long-primer t-text-left"
        @click="chooseSuggestedSearch(suggestedSearch, productsSearchFromStoreContext)"
        v-html="getHighlightedSuggestedSearchHtml(suggestedSearch.text)"
      />
      <!-- eslint-enable -->
    </div>
  </div>
</div>
